'use strict';

/**
 * @name Novicell Slider
 * @desc Slider, for custom arrow use https://flickity.metafizzy.co/options.html#arrowshape
 * @author Emil Ankersen (EAN)
 * @requires https://flickity.metafizzy.co/
 */


var novicell = novicell || {};

novicell.slider = novicell.slider || new function () {

    this.init = function () {
        const sliders = document.querySelectorAll('.js-slider');
        for (let i = 0; i < sliders.length; i++) {
            const element = sliders[i];
            if (element && element != null) {
                let flkty = new Flickity(element, {
                    // options
                    cellAlign: 'left',
                    contain: true,
                    bgLazyLoad: 1,
                    autoPlay: 5000
                });
            }

        }

        video();

        window.addEventListener('resize', function () {
            video();
        });

        function video() {
            const videoElements = document.querySelectorAll('.js-slider-video');
            for (let i = 0; i < videoElements.length; i++) {
                const videoElement = videoElements[i];
                let videoSrc = videoElement.getAttribute('data-src-desktop');
                let mobileSrc = videoElement.getAttribute('data-src-mobile');

                if (window.innerWidth < 767 ) {
                    if (mobileSrc != '') {
                        videoSrc = mobileSrc;
                    } else {
                        return;
                    }
                }
                videoElement.setAttribute('src', videoSrc);
            }
        }
    };
}();
